var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 15,
    fill: "#D1D5DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4998 13.103C22.8603 11.6697 25.8361 9.86282 26.8118 11.5405C27.53 12.7752 26.1106 14.0615 24.3331 15.1722C24.2697 15.2206 24.2023 15.2655 24.1312 15.3062L23.6276 15.5949C23.5832 15.6205 23.5387 15.646 23.4942 15.6713L21.5685 16.775C21.8414 19.3864 22.1174 23.1569 22.0958 25.3559C22.0745 27.5126 20.8725 28.3884 19.9476 28.5504L17.768 18.9533L12.931 21.7256C12.7466 22.4694 12.5373 23.2206 12.3455 23.7625C12.0207 24.6795 11.1851 25.2222 10.6162 25.4228L10.722 21.5943C10.5659 21.4624 10.4295 21.3021 10.3211 21.1157C10.2389 20.9744 10.1779 20.8267 10.137 20.6764L6.7765 18.882C7.23902 18.4914 8.13547 18.0413 9.10176 18.2185C9.61001 18.3117 10.2704 18.4756 10.9341 18.66C10.9517 18.6491 10.9696 18.6384 10.9877 18.628L15.8456 15.8437L8.72125 9.33846C9.32958 8.62166 10.7024 8.02175 12.6002 9.0786C14.4651 10.1171 17.4674 12.1214 19.6048 13.6412C19.8884 13.4742 20.1887 13.2918 20.4998 13.103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericSmallLogo);
export default __webpack_public_path__ + "static/media/generic-small-logo.b0ec5792ed5be56c77767967d6fe9691.svg";
export { ForwardRef as ReactComponent };